import React from 'react';

const BetaFooter = () => (
  <footer data-testid="beta-footer" className="mt-12 border-t border-gray-200 bg-white">
    <div className="max-w-7xl mx-auto px-6 py-4 flex flex-col sm:flex-row items-center justify-between gap-2 text-xs text-gray-500">
      <span>© {new Date().getFullYear()} CUALAPP — Beta privada.</span>
      <div className="flex items-center gap-3">
        <a href="/terms-beta" className="hover:text-purple-700" data-testid="footer-terms">Terminos</a>
        <a href="/privacy" className="hover:text-purple-700" data-testid="footer-privacy">Privacidad</a>
        <a href="mailto:soporte@cualapp.com" className="hover:text-purple-700" data-testid="footer-support">soporte@cualapp.com</a>
      </div>
    </div>
  </footer>
);

export default BetaFooter;
